import {useState, useCallback} from 'react';
import NetInfo from '@react-native-community/netinfo';

export const useNetworkState = () => {
  const [isConnected, setIsConnected] = useState(true);

  const checkNetworkState = useCallback(async () => {
    const networkState = await NetInfo.fetch();
    const connected = networkState?.isConnected ?? true;
    setIsConnected(connected);
    return connected;
  }, []);

  return {isConnected, checkNetworkState};
};
